import React, { useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import { Outlet } from "react-router-dom";
import CustomFooter from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import "./assets/css/index.css";
import CustomChatBot from "./components/CustomChatBot";
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);
  return (
    <>
      <Navbar />
      <main className="pt-[120px]">
        <Outlet />
      </main>
      <CustomChatBot/>
      <ScrollToTopButton />
      <CustomFooter />
    </>
  );
};

export default App;
